import { Button, Grid, makeStyles, Modal, Paper, Theme } from '@material-ui/core';
import { useGetSupplierQuery, UserServiceContractsDtosUserProfileDto } from 'api';
import { useDebounceRefetch } from 'hooks/useDebounceRefetch';
import { get, isEmpty, noop } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { SupplierSearchResults } from './SupplierSearchResult';
import { InputFullWidth } from './TableRowInput';

export interface SupplierSearchModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSelect: (userProfileDto: UserServiceContractsDtosUserProfileDto) => void;
	selectedValue?: UserServiceContractsDtosUserProfileDto;
	officeEntityId?: string;
}

const rand = () => {
	return Math.round(Math.random() * 20) - 10;
};
const getModalStyle = () => {
	const top = 50 + rand();
	const left = 50 + rand();

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`
	};
};

const useStyles = makeStyles((theme) => ({
	paper: {
		position: 'absolute',
		minWidth: 400,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(1, 2, 1)
	}
}));

export const SupplierSearchModal = ({ isOpen, onClose, onSelect, selectedValue, officeEntityId }: SupplierSearchModalProps) => {
	const classes = useStyles();
	const [modalStyle] = React.useState(getModalStyle);
	const [supplierSearchTerm, setSupplierSearchTerm] = useState<string | undefined | null>(undefined);
	const [currentPage, setPage] = React.useState(0);
	let search = undefined;
	if (supplierSearchTerm) search = { profileName: supplierSearchTerm, officeEntityId };
	const args = { search, currentPage };
	const { data, isLoading, refetch, isFetching, abort = noop } = useGetSupplierQuery(args, { retry: false, enabled: false });

	const onSupplierChange = (entity?: UserServiceContractsDtosUserProfileDto | undefined) => {
		if (!entity) {
			console.log('no supplier entity');
			return;
		}
		if (!entity?.userDetail) {
			console.log('no supplier userDetail');
			return;
		}
		if (!entity?.userProfileId) {
			console.log('no supplier userProfileId');
			return;
		}

		onSelect(entity);
	};

	const onTextChange = (e: React.SyntheticEvent) => {
		const value: string | null = get(e, 'target.value', undefined);
		setSupplierSearchTerm(value);
	};

	const { exec } = useDebounceRefetch(refetch, supplierSearchTerm, abort);

	const changePageCallback = useCallback(() => {
		if (isLoading || isFetching) return;
		if (!officeEntityId) return;
		refetch();
	}, [currentPage]);

	useEffect(() => {
		if (isLoading || isFetching) return;
		if (!supplierSearchTerm) return;
		if (!officeEntityId) return;
		if (!isEmpty(supplierSearchTerm)) exec();
		return () => abort();
	}, [supplierSearchTerm]);

	const changePageWithCallback = (page: number) => {
		setPage(page);
		changePageCallback();
	};

	const ModalBody = (
		<Paper style={modalStyle} className={classes.paper}>
			<Grid container item alignContent="center">
				<InputFullWidth onChange={onTextChange} />
			</Grid>

			<SupplierSearchResults
				loading={isLoading}
				data={data}
				setPage={changePageWithCallback}
				currentPage={currentPage}
				onChange={onSupplierChange}
				selectedValue={selectedValue}
			></SupplierSearchResults>
			<Button variant="contained" color="secondary" onClick={onClose}>
				Cancel
			</Button>
		</Paper>
	);

	return (
		<Modal open={isOpen} disableBackdropClick onClose={onClose} aria-labelledby="supplier-select" aria-describedby="supplier-select">
			{ModalBody}
		</Modal>
	);
};
